import { render, staticRenderFns } from "./RequirementsStatus.vue?vue&type=template&id=09aa80d2&"
import script from "./RequirementsStatus.vue?vue&type=script&lang=js&"
export * from "./RequirementsStatus.vue?vue&type=script&lang=js&"
import style0 from "./RequirementsStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports